export default "__VITE_ASSET__78385810__"